import React from 'react';

import { Grid } from '@material-ui/core';

import Nav     from 'pages/login/molecules/nav';
import Form    from 'pages/login/molecules/form';

import 'styles/login.css';

function App (props) {
    return (
        <Grid container spacing={0} className="login-body-container">
            <Grid item xs={6} className="login-img-container">
            </Grid>
            <Grid item xs={6} container justify = 'center' alignItems = 'center' >
				<Grid className = 'form-container'>
					<Nav />
					<Form { ...props }/>
				</Grid>
            </Grid>
        </Grid>
		);
}

export default App;
